// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("resources/default/fonts/bta-icons.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("resources/default/fonts/bta-icons.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("resources/default/fonts/bta-icons.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("resources/default/fonts/bta-icons.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("resources/default/fonts/Eina02-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("resources/default/fonts/eina02-regular-webfont.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("resources/default/fonts/eina02-regular-webfont.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("resources/default/fonts/Eina02-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("resources/default/fonts/eina02-bold-webfont.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("resources/default/fonts/eina02-bold-webfont.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("resources/default/fonts/Eina02-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("resources/default/fonts/eina02-semibold-webfont.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("resources/default/fonts/eina02-semibold-webfont.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___, { hash: "#bta-icons" });
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'bta icons';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('embedded-opentype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff'),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('svg');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "Eina 02";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('truetype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('woff'),
    url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('woff2');
  font-weight: 400;
  font-style: normal;
}
@font-face {
  font-family: "Eina 02";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format('truetype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format('woff'),
    url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format('woff2');
  font-weight: 700;
  font-style: normal;
}
@font-face {
  font-family: "Eina 02";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format('truetype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format('woff'),
    url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format('woff2');
  font-weight: 600;
  font-style: normal;
}

*{
  scrollbar-width: thin;
  scrollbar-color: #D3D5E6;
}


html, body {
  height: 100%;
}

body {
  margin: 0;
  font-family: 'Eina 02','Roboto',-apple-system, BlinkMacSystemFont,  'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #fff!important;  
  font-size: 0.875rem;
  line-height: 1.43;
  letter-spacing: 0.01071em;
}
p{
  line-height: 1.75rem;
}
a{
  background-color: transparent!important;
  text-decoration-color: transparent!important;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}
code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

[class*='bta-icon-']:before{
  display: inline-block;
  font-family: 'bta icons';
  font-style: normal;
  font-weight: normal;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale
}

.bta-icon-exclamation:before{content:'\\0041';}
.bta-icon-attachment:before{content:'\\0042';}
.bta-icon-send-email:before{content:'\\0043';}
.bta-icon-bell:before{content:'\\0044';}
.bta-icon-file:before{content:'\\0045';}
.bta-icon-chevron-left:before{content:'\\0046';}
.bta-icon-chevron-right:before{content:'\\0047';}
.bta-icon-times:before{content:'\\0048';} /* close */
.bta-icon-check:before{content:'\\0049';}
.bta-icon-filter:before{content:'\\004a';}
.bta-icon-analytics-graph-bar:before{content:'\\004b';}
.bta-icon-door-code:before{content:'\\004c';}
.bta-icon-home-with-remote:before{content:'\\004d';}
.bta-icon-log-out:before{content:'\\004e';}
.bta-icon-settings-gear:before{content:'\\004f';}
.bta-icon-shield:before{content:'\\0050';}
.bta-icon-wrench:before{content:'\\0051';}
.bta-icon-files:before{content:'\\0052';}
.bta-icon-home:before{content:'\\0053';}
.bta-icon-menu:before{content:'\\0054';}
.bta-icon-message:before{content:'\\0055';}
.bta-icon-wallet:before{content:'\\0056';}

 input:-webkit-autofill {
   -webkit-box-shadow: 0 0 0 1000px white inset!important;
 }
 input:autofill {
   box-shadow: 0 0 0 1000px white inset!important;
}

h2{
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/resources/default/styles.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,4CAAiD;EACjD;;;yDAGsE;EACtE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB;;2DAE6E;EAC7E,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB;;4DAE0E;EAC1E,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB;;4DAE8E;EAC9E,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;AAC1B;;;AAGA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,gCAAgC;EAChC,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,oBAAoB;AACtB;AACA;EACE,uCAAuC;EACvC,4CAA4C;EAC5C,2BAA2B;EAC3B,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,wCAAwC;AAC1C;AACA;EACE;aACW;AACb;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,mCAAmC;EACnC;AACF;;AAEA,6BAA6B,eAAe,CAAC;AAC7C,4BAA4B,eAAe,CAAC;AAC5C,4BAA4B,eAAe,CAAC;AAC5C,sBAAsB,eAAe,CAAC;AACtC,sBAAsB,eAAe,CAAC;AACtC,8BAA8B,eAAe,CAAC;AAC9C,+BAA+B,eAAe,CAAC;AAC/C,uBAAuB,eAAe,CAAC,EAAE,UAAU;AACnD,uBAAuB,eAAe,CAAC;AACvC,wBAAwB,eAAe,CAAC;AACxC,qCAAqC,eAAe,CAAC;AACrD,2BAA2B,eAAe,CAAC;AAC3C,kCAAkC,eAAe,CAAC;AAClD,yBAAyB,eAAe,CAAC;AACzC,+BAA+B,eAAe,CAAC;AAC/C,wBAAwB,eAAe,CAAC;AACxC,wBAAwB,eAAe,CAAC;AACxC,uBAAuB,eAAe,CAAC;AACvC,sBAAsB,eAAe,CAAC;AACtC,sBAAsB,eAAe,CAAC;AACtC,yBAAyB,eAAe,CAAC;AACzC,wBAAwB,eAAe,CAAC;;CAEvC;GACE,sDAAsD;CACxD;CACA;GACE,8CAA8C;AACjD;;AAEA;EACE,SAAS;AACX","sourcesContent":["@font-face {\n  font-family: 'bta icons';\n  src: url('resources/default/fonts/bta-icons.eot');\n  src: url('resources/default/fonts/bta-icons.eot?#iefix') format('embedded-opentype'),\n    url('resources/default/fonts/bta-icons.woff') format('woff'),\n    url('resources/default/fonts/bta-icons.ttf') format('truetype'),\n    url('resources/default/fonts/bta-icons.svg#bta-icons') format('svg');\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Eina 02\";\n  src: url('resources/default/fonts/Eina02-Regular.ttf') format('truetype'),\n    url('resources/default/fonts/eina02-regular-webfont.woff') format('woff'),\n    url('resources/default/fonts/eina02-regular-webfont.woff2') format('woff2');\n  font-weight: 400;\n  font-style: normal;\n}\n@font-face {\n  font-family: \"Eina 02\";\n  src: url('resources/default/fonts/Eina02-Bold.ttf') format('truetype'),\n    url('resources/default/fonts/eina02-bold-webfont.woff') format('woff'),\n    url('resources/default/fonts/eina02-bold-webfont.woff2') format('woff2');\n  font-weight: 700;\n  font-style: normal;\n}\n@font-face {\n  font-family: \"Eina 02\";\n  src: url('resources/default/fonts/Eina02-SemiBold.ttf') format('truetype'),\n    url('resources/default/fonts/eina02-semibold-webfont.woff') format('woff'),\n    url('resources/default/fonts/eina02-semibold-webfont.woff2') format('woff2');\n  font-weight: 600;\n  font-style: normal;\n}\n\n*{\n  scrollbar-width: thin;\n  scrollbar-color: #D3D5E6;\n}\n\n\nhtml, body {\n  height: 100%;\n}\n\nbody {\n  margin: 0;\n  font-family: 'Eina 02','Roboto',-apple-system, BlinkMacSystemFont,  'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: #fff!important;  \n  font-size: 0.875rem;\n  line-height: 1.43;\n  letter-spacing: 0.01071em;\n}\np{\n  line-height: 1.75rem;\n}\na{\n  background-color: transparent!important;\n  text-decoration-color: transparent!important;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  -webkit-tap-highlight-color: transparent;\n}\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n[class*='bta-icon-']:before{\n  display: inline-block;\n  font-family: 'bta icons';\n  font-style: normal;\n  font-weight: normal;\n  line-height: 1;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale\n}\n\n.bta-icon-exclamation:before{content:'\\0041';}\n.bta-icon-attachment:before{content:'\\0042';}\n.bta-icon-send-email:before{content:'\\0043';}\n.bta-icon-bell:before{content:'\\0044';}\n.bta-icon-file:before{content:'\\0045';}\n.bta-icon-chevron-left:before{content:'\\0046';}\n.bta-icon-chevron-right:before{content:'\\0047';}\n.bta-icon-times:before{content:'\\0048';} /* close */\n.bta-icon-check:before{content:'\\0049';}\n.bta-icon-filter:before{content:'\\004a';}\n.bta-icon-analytics-graph-bar:before{content:'\\004b';}\n.bta-icon-door-code:before{content:'\\004c';}\n.bta-icon-home-with-remote:before{content:'\\004d';}\n.bta-icon-log-out:before{content:'\\004e';}\n.bta-icon-settings-gear:before{content:'\\004f';}\n.bta-icon-shield:before{content:'\\0050';}\n.bta-icon-wrench:before{content:'\\0051';}\n.bta-icon-files:before{content:'\\0052';}\n.bta-icon-home:before{content:'\\0053';}\n.bta-icon-menu:before{content:'\\0054';}\n.bta-icon-message:before{content:'\\0055';}\n.bta-icon-wallet:before{content:'\\0056';}\n\n input:-webkit-autofill {\n   -webkit-box-shadow: 0 0 0 1000px white inset!important;\n }\n input:autofill {\n   box-shadow: 0 0 0 1000px white inset!important;\n}\n\nh2{\n  margin: 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
